import { toast } from 'sonner';

let lastToastKey: string | null = null;
let lastToastAtMs = 0;

/**
 * Shows a toast at most once per time window for the same key.
 * Useful for deduping global errors that can fan out across queries.
 */
export const toastErrorOnce = (
  key: string,
  message: string,
  windowMs = 4000
): void => {
  const now = Date.now();

  if (lastToastKey === key && now - lastToastAtMs < windowMs) {
    return;
  }

  lastToastKey = key;
  lastToastAtMs = now;

  toast.error(message);
};
